import { render, staticRenderFns } from "./MdmBackToTop.vue?vue&type=template&id=0a33edaa&name=mdm-back-to-top&"
import script from "./MdmBackToTop.vue?vue&type=script&lang=js&"
export * from "./MdmBackToTop.vue?vue&type=script&lang=js&"
import style0 from "./MdmBackToTop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports